/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { GuidanceStatus } from './GuidanceStatus.js';
import {
    GuidanceStatusFromJSON,
    GuidanceStatusFromJSONTyped,
    GuidanceStatusToJSON,
} from './GuidanceStatus.js';
import type { GuidanceType } from './GuidanceType.js';
import {
    GuidanceTypeFromJSON,
    GuidanceTypeFromJSONTyped,
    GuidanceTypeToJSON,
} from './GuidanceType.js';

/**
 * 
 * @export
 * @interface Guidance
 */
export interface Guidance {
    /**
     * 
     * @type {number}
     * @memberof Guidance
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Guidance
     */
    contactId?: number;
    /**
     * 
     * @type {string}
     * @memberof Guidance
     */
    name?: string;
    /**
     * 
     * @type {GuidanceType}
     * @memberof Guidance
     */
    type?: GuidanceType;
    /**
     * 
     * @type {string}
     * @memberof Guidance
     */
    icon?: string;
    /**
     * 
     * @type {Array<any>}
     * @memberof Guidance
     */
    content?: Array<any>;
    /**
     * 
     * @type {Date}
     * @memberof Guidance
     */
    dateCreated?: Date;
    /**
     * 
     * @type {GuidanceStatus}
     * @memberof Guidance
     */
    status?: GuidanceStatus;
}

/**
 * Check if a given object implements the Guidance interface.
 */
export function instanceOfGuidance(value: object): boolean {
    return true;
}

export function GuidanceFromJSON(json: any): Guidance {
    return GuidanceFromJSONTyped(json, false);
}

export function GuidanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Guidance {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'contactId': json['contactId'] == null ? undefined : json['contactId'],
        'name': json['name'] == null ? undefined : json['name'],
        'type': json['type'] == null ? undefined : GuidanceTypeFromJSON(json['type']),
        'icon': json['icon'] == null ? undefined : json['icon'],
        'content': json['content'] == null ? undefined : json['content'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'status': json['status'] == null ? undefined : GuidanceStatusFromJSON(json['status']),
    };
}

export function GuidanceToJSON(value?: Guidance | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'contactId': value['contactId'],
        'name': value['name'],
        'type': GuidanceTypeToJSON(value['type']),
        'icon': value['icon'],
        'content': value['content'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
        'status': GuidanceStatusToJSON(value['status']),
    };
}

